import { render, staticRenderFns } from "./group-button.component.vue?vue&type=template&id=faaf69aa&scoped=true&lang=pug"
import script from "./group-button.component.vue?vue&type=script&lang=ts"
export * from "./group-button.component.vue?vue&type=script&lang=ts"
import style0 from "./group-button.component.vue?vue&type=style&index=0&id=faaf69aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaf69aa",
  null
  
)

export default component.exports